import * as React from 'react';
import PropTypes from 'prop-types';

import Layout from '../components/Layouts/Layout';
import WinnersLayout from '../components/Layouts/WinnersLayout';
import TextBlock from '../components/TextBlock/TextBlock';
import VideoHero from '../components/Video/VideoHero';
import AlumniListing from '../components/Winners/AlumniListing';

import FreshFundOGImage from '../images/og/freshfund.png';
import '../sass/main.scss';

// Winners Illustrations
import AnisaIllustration from '../images/portrait/anisa.png';
import LeahIllustration from '../images/portrait/leah.png';
import SaraIllustration from '../images/portrait/sara.png';
import KendallIllustration from '../images/portrait/kendall.png';
import HaniIllustration from '../images/portrait/hani.png';
import JaynikaIllustration from '../images/portrait/jay.png';
import SaVonneIllustration from '../images/portrait/savonne.png';
import Metadata from '../components/Metadata/Metadata';

const ourWinners = [
  {
    name: 'Anisa Sloan',
    company: 'Souvinear',
    image: AnisaIllustration,
    slug: '/winners/anisa-sloan/',
  },
  {
    name: 'Leah Hernandez',
    company: 'Young Authors Publishing',
    image: LeahIllustration,
    slug: '/winners/leah-hernandez/',
  },
  {
    name: 'Sara Berkai',
    company: 'Ambessa Play',
    image: SaraIllustration,
    slug: '/winners/sara-berkai/',
  },
  {
    name: 'Kendall Finlay',
    company: 'Ohm',
    image: KendallIllustration,
    slug: '/winners/kendall-finlay/',
  },
  {
    name: 'Dr Hani Hassan',
    company: 'Hue by Dr Hani',
    image: HaniIllustration,
    slug: '/winners/dr-hani-hassan/',
  },
  {
    name: 'Jaynika McGregor',
    company: 'Graceful Graves',
    image: JaynikaIllustration,
    slug: '/winners/jaynika-mcgregor/',
  },
  {
    name: 'SaVonne Anderson',
    company: 'Aya Paper Co',
    image: SaVonneIllustration,
    slug: '/winners/savonne-anderson/',
  },
];

export default function OurWinners({ location }) {
  return (
    <>
      <Metadata />
      <Layout round='1' customClass='application-header--small'>
        <div className='uk-container uk-margin-large-bottom'>
          <div className='uk-grid' data-uk-grid>
            <div className='uk-width-2-3@m'>
              <TextBlock
                subheading='Fresh Fund'
                heading='Alumni'
                content="<p>From a mobile grave-cleaning service to an intelligent skincare brand for POC, our class of 2021 showcased a wide variety of businesses and inspirations for how they came to be. This was Courier's inaugural Fresh Fund and we couldn't have asked for a better cohort to kick off the first program.</p>"
              />
            </div>
          </div>
        </div>
        <WinnersLayout>
          <div className='uk-container'>
            <div className='uk-grid uk-child-width-1-2@s' data-uk-grid>
              <AlumniListing winners={ourWinners} />
            </div>
            <div className='fresh-fund-winners-video uk-margin-large-top uk-margin-large-bottom'>
              <VideoHero wistiaID='iyj7ysbh3u' />
            </div>
          </div>
        </WinnersLayout>
      </Layout>
    </>
  );
}

OurWinners.propTypes = {
  location: PropTypes.object.isRequired,
};
